module.exports = __webpack_public_path__ + "static/lets_connect-30b2c13ccf7ccaf49c3adf43bc415d8a.png";